import Styles from './styles.module.css';
import React, { useEffect, useState } from 'react';
import { doc, DocumentData, getDoc, getFirestore, Timestamp } from "firebase/firestore";
import { DocumentSnapshot } from 'firebase-admin/firestore';
import { RxCross2 } from "react-icons/rx";

export type FirestoreDate = Date | Timestamp;


type SchoolTypeProps = {
  report: string;
  setReport: React.Dispatch<React.SetStateAction<string>>;
};

const SchoolType: React.FC<SchoolTypeProps> = ({ report, setReport }) => {

  const db = getFirestore();
  
  const [ reportList, setReportList ] = useState<InterviewReport>(defaultInterviewReport);
  const [ loading, setLoading ] = useState(true);

  useEffect(() => {
    if (!report) return;

    const load = async () => {
      setLoading(true);

      const reportRef = doc(db, "interviews", report);
      const reportSnap = await getDoc(reportRef);

      if (!reportSnap.exists()) {
        setLoading(false);
        return;
      }

      const formatted = formatInterviewReport(
        reportSnap.id,
        reportSnap.data()
      );

      setReportList(formatted);
      setLoading(false);
    };

    load();
  }, [report]);

  const formatInterviewReport = (
    id: string,
    data: DocumentData
  ): InterviewReport => {
    return {
      uid: data.uid ?? id,
      name: data.name ?? "",
      schoolName: data.schoolName ?? "",
      salonName: data.salonName ?? "",

      question1: data.question1 ?? "",
      question2: data.question2 ?? "",
      question3: data.question3 ?? "",
      question4: data.question4 ?? "",
      question5: data.question5 ?? "",

      time: data.time ?? new Date(),
    };
  };


  return (
    <>
    <div className={Styles.modal}>
      <div className={Styles.background_black} onClick={() => setReport("")}></div>
      <div className={Styles.contents}>
        <div className={Styles.modal_title}>
          <h4>レポート</h4>
          <RxCross2 className={Styles.modal_cross} onClick={() => setReport("")} />
        </div>

        <img src={`https://firebasestorage.googleapis.com/v0/b/trankllc-com.appspot.com/o/interviewsReport%2Fresize_images%2F${report}_1080x1080?alt=media&token=`} />
        <h6>※掲載時には学校様名、学生様の氏名、サロン名、サロンのアイコンを画像に付け加えて投稿いたします。</h6>
        <h4>名前</h4>
        <p>{reportList.name}</p>
        <h4>サロン名</h4>
        <p>{reportList.salonName}</p>
        <h4>出身学校</h4>
        <p>{reportList.schoolName}</p>
        <h4>1.美容学生時代に頑張った事は？</h4>
        <p>{reportList.question1}</p>
        <h4>2.どのような理由で{reportList.salonName}を志望しましたか？</h4>
        <p>{reportList.question2}</p>
        <h4>3.選考はどのような流れでしたか？また、対策はありますか？</h4>
        <p>{reportList.question3}</p>
        <h4>4.どんな美容師になりたいですか？</h4>
        <p>{reportList.question4}</p>
        <h4>5.現在就活している1年生に対するアドバイスをください。</h4>
        <p>{reportList.question5}</p>
      </div>
    </div>
    </>
  );
}

export default SchoolType;


export type InterviewReport = {
  uid: string;
  name: string;
  schoolName: string;
  salonName: string;

  question1: string;
  question2: string;
  question3: string;
  question4: string;
  question5: string;

  time: FirestoreDate;
};

export const defaultInterviewReport: InterviewReport = {
  uid: "",
  name: "",
  schoolName: "",
  salonName: "",

  question1: "",
  question2: "",
  question3: "",
  question4: "",
  question5: "",

  time: new Date(),
};

export const formatInterviewReport = (
  snap: DocumentSnapshot<DocumentData>
): InterviewReport => {
  const data = snap.data();
  if (!data) throw new Error("InterviewReport data is undefined");

  return {
    uid: data.uid ?? snap.id,
    name: data.name ?? "",
    schoolName: data.schoolName ?? "",
    salonName: data.salonName ?? "",

    question1: data.question1 ?? "",
    question2: data.question2 ?? "",
    question3: data.question3 ?? "",
    question4: data.question4 ?? "",
    question5: data.question5 ?? "",

    time: data.time ?? new Date(),
  };
};